import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {AuthPolicyVO, TopLevelDomainVO} from '../../../generate/TopLevelDomainVO';
import {ChangeVO} from '../../../generate/ChangeVO';

@Component({
  selector: 'lib-auth-policy',
  templateUrl: './auth-policy-screen.component.html',
  styleUrls: ['./auth-policy-screen.component.scss']
})
export class AuthPolicyScreenComponent implements  OnChanges  {

  @Input()
  domain: TopLevelDomainVO;

  @Input()
  pendingRequestChangeID: string;

  @Input()
  lastchange: string;

  @Input()
  authPolicyChange: ChangeVO;

  @Input()
  authPolicyUsersChange: ChangeVO;

  @Input()
  viewMode: boolean;

  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomainVO>();

  editMode: boolean;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  edit($event: boolean) {
    this.editMode = $event;
  }

  cancel($event: boolean) {
    this.edit(false);
  }

  authPolicyVOOutput(authPolicyVO: AuthPolicyVO) {
    this.domain.authPolicy = authPolicyVO;
    this.modifiedTLDOutput.emit(this.domain);
    this.edit(false);
  }
}
